import React from 'react';
import { Users, Plus, Search, Filter, Phone, Mail, Calendar } from 'lucide-react';

const Customers = () => {
  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-6 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
        <div>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', marginBottom: '8px' }}>
            👥 Müşteriler
          </h1>
          <p style={{ color: '#6B7280' }}>Aktif müşterilerinizi yönetin</p>
        </div>
        <button style={{
          padding: '12px 24px',
          backgroundColor: '#10B981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 2px 8px rgba(16,185,129,0.3)'
        }}>
          <Plus size={20} />
          Yeni Müşteri Ekle
        </button>
      </div>

      {/* Arama ve Filtre */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        marginBottom: '24px',
        display: 'flex',
        gap: '12px'
      }}>
        <div style={{ flex: 1, position: 'relative' }}>
          <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }} size={20} />
          <input
            type="text"
            placeholder="Müşteri ara..."
            style={{
              width: '100%',
              padding: '10px 10px 10px 44px',
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              fontSize: '14px'
            }}
          />
        </div>
        <button style={{
          padding: '10px 20px',
          backgroundColor: 'white',
          border: '1px solid #E5E7EB',
          borderRadius: '8px',
          color: '#374151',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Filter size={18} />
          Filtrele
        </button>
      </div>

      {/* Müşteri Listesi - Tablo Görünümü */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#F9FAFB', borderBottom: '1px solid #E5E7EB' }}>
            <tr>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '14px', fontWeight: '600', color: '#6B7280' }}>Müşteri</th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '14px', fontWeight: '600', color: '#6B7280' }}>Şirket</th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '14px', fontWeight: '600', color: '#6B7280' }}>İletişim</th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '14px', fontWeight: '600', color: '#6B7280' }}>Son Görüşme</th>
              <th style={{ padding: '16px', textAlign: 'left', fontSize: '14px', fontWeight: '600', color: '#6B7280' }}>Durum</th>
            </tr>
          </thead>
          <tbody>
            {[
              { name: 'Ali Veli', company: 'Tech Solutions', phone: '0555 111 2233', email: 'ali@tech.com', lastContact: '2 gün önce', status: 'Aktif', statusColor: '#10B981' },
              { name: 'Zeynep Aydın', company: 'Digital Agency', phone: '0555 222 3344', email: 'zeynep@digital.com', lastContact: '1 hafta önce', status: 'Aktif', statusColor: '#10B981' },
              { name: 'Burak Koç', company: 'Marketing Pro', phone: '0555 333 4455', email: 'burak@marketing.com', lastContact: '3 gün önce', status: 'Aktif', statusColor: '#10B981' },
              { name: 'Selin Yurt', company: 'E-Commerce Plus', phone: '0555 444 5566', email: 'selin@ecommerce.com', lastContact: '5 gün önce', status: 'Aktif', statusColor: '#10B981' },
              { name: 'Deniz Şahin', company: 'Startup Inc.', phone: '0555 555 6677', email: 'deniz@startup.com', lastContact: '1 gün önce', status: 'Aktif', statusColor: '#10B981' },
            ].map((customer, index) => (
              <tr key={index} style={{
                borderBottom: '1px solid #E5E7EB',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}>
                <td style={{ padding: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '50%',
                      backgroundColor: '#DBEAFE',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#3B82F6'
                    }}>
                      {customer.name.charAt(0)}
                    </div>
                    <div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>{customer.name}</div>
                    </div>
                  </div>
                </td>
                <td style={{ padding: '16px', fontSize: '14px', color: '#6B7280' }}>{customer.company}</td>
                <td style={{ padding: '16px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <div style={{ fontSize: '13px', color: '#6B7280', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Phone size={14} />
                      {customer.phone}
                    </div>
                    <div style={{ fontSize: '13px', color: '#6B7280', display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <Mail size={14} />
                      {customer.email}
                    </div>
                  </div>
                </td>
                <td style={{ padding: '16px', fontSize: '14px', color: '#6B7280' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Calendar size={16} />
                    {customer.lastContact}
                  </div>
                </td>
                <td style={{ padding: '16px' }}>
                  <span style={{
                    padding: '4px 12px',
                    backgroundColor: `${customer.statusColor}20`,
                    color: customer.statusColor,
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '500'
                  }}>
                    {customer.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Customers;